






























import GrpTagChoice from "@/interfaces/GrpTagChoice";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import VCheckbox from "../VCheckbox.vue";

@Component({ components: { VCheckbox } })
export default class AgePanel extends Vue {
  @Prop({ default: false }) readonly childrenSelected!: boolean;
  @Prop({ default: false }) readonly buyersSelected!: boolean;
  ages = [
    {
      label: "4-7",
      tag: "4_7",
      selected: false,
      buyers: false,
    },
    {
      label: "8-14",
      tag: "8_14",
      selected: false,
      buyers: false,
    },
    {
      label: "15-19",
      tag: "15_19",
      selected: false,
      buyers: false,
    },
    {
      label: "20-24",
      tag: "20_24",
      selected: false,
      buyers: false,
    },
    {
      label: "25-34",
      tag: "25_34",
      buyers: true,
      selected: false,
    },
    {
      label: "35-44",
      tag: "35_44",
      buyers: true,
      selected: false,
    },
    {
      label: "45-54",
      tag: "45_54",
      buyers: true,
      selected: false,
    },
    {
      label: "55-64",
      tag: "55_64",
      buyers: true,
      selected: false,
    },
    {
      label: "65+",
      tag: "over_64",
      buyers: true,
      selected: false,
    },
  ];

  init(choice: GrpTagChoice | null) {
    const tags = choice?.tag as string[];
    this.ages = this.ages.map((age) => {
      return {
        label: age.label,
        tag: age.tag,
        buyers: age.buyers,
        selected: !!tags.find((tag) => tag == age.tag),
      };
    });
    if (this.buyersSelected) {
      this.ages = this.ages.filter((age) => age.buyers);
    }
    this.notify();
  }

  onSelectAllClick() {
    this.ages = this.ages.map((age) => {
      return {
        label: age.label,
        buyers: age.buyers,
        tag: age.tag,
        selected: true,
      };
    });
    this.notify();
  }

  notify() {
    const choice: GrpTagChoice = {
      tag: [],
      type: "list",
      isValid: false,
    };
    if (this.childrenSelected) {
      choice.isValid = true;
    } else {
      const selected = this.ages.filter((age) => {
        return age.selected;
      });
      if (selected.length > 0) {
        choice.isValid = true;
        choice.tag = [...selected.map((age) => age.tag)];
      }
    }
    this.$emit("choice", choice);
  }

  onCheckClick(selected: boolean) {
    this.notify();
  }
}
